module.exports = "<div class=\"input-group input-group-sm\"><span class=\"input-group-addon btn btn-default btn-sm\" (click)=\"this.goToPage('rewind')\"><span class=\"glyphicon glyphicon-step-backward\"></span></span><input class=\"form-control\" [(ngModel)]=\"this.pagination.page\" type=\"number\" aria-label=\"\" min=\"1\" max=\"{{this.pagination.pages}}\"><span class=\"input-group-addon btn btn-default btn-sm\" (click)=\"this.goToPage('forward')\"><span class=\"glyphicon glyphicon-step-forward\"></span></span></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/paginator/paginator.component.pug
// module id = 1160
// module chunks = 1